import React from 'react'
import { WalletTypes } from 'types/types'
import { AddCustomerWallet } from './AddCustomerWallet'

interface AddWalletProps {
  walletType: WalletTypes
  handleClose?: () => void
}

export const AddWallet = ({ walletType = WalletTypes?.CUSTOMER, handleClose }: AddWalletProps) => {
  if (walletType === WalletTypes?.CUSTOMER) {
    return <AddCustomerWallet handleClose={handleClose} />
  }
}
